module.exports = __webpack_public_path__ + "static/media/dsn.f2281ec4.png";